// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agents-container {
  width: 81.7% !important;
  margin-left: 18% !important;
}
@media (max-width: 1024px) {
  .agents-container {
    width: 100% !important;
    margin-left: 0px !important;
  }
}
.agents-container .css-11xur9t-MuiPaper-root-MuiTableContainer-root {
  border-radius: 0px !important;
  width: 97% !important;
  height: 64vh;
  scroll-behavior: none;
}
.agents-container .css-11xur9t-MuiPaper-root-MuiTableContainer-root .css-15wwp11-MuiTableHead-root {
  height: 0px !important;
}
.agents-container .css-11xur9t-MuiPaper-root-MuiTableContainer-root .css-y8ay40-MuiTableCell-root {
  background-color: white !important;
  border: 0px !important;
}
.agents-container .css-11xur9t-MuiPaper-root-MuiTableContainer-root .css-1ex1afd-MuiTableCell-root {
  background-color: #D9D9D9;
  border-bottom: 28px solid white !important;
}
.agents-container .css-11xur9t-MuiPaper-root-MuiTableContainer-root .profilePicCell {
  background-color: white !important;
}
.agents-container .css-apqrd9-MuiTableBody-root {
  border: 2px solid red !important;
}
.agents-container .css-13xy2my {
  border-radius: 0px !important;
  width: 97% !important;
  height: 64vh;
}
.agents-container .css-13xy2my .css-1wbz3t9 {
  height: 0px !important;
}
.agents-container .css-13xy2my .css-8coetn {
  background-color: white !important;
  border: 0px !important;
}
.agents-container .css-13xy2my .css-q34dxg {
  background-color: #D9D9D9;
  border-bottom: 28px solid white !important;
}

.policiesDataGrid .css-11xur9t-MuiPaper-root-MuiTableContainer-root {
  border-radius: 0px !important;
  width: 97% !important;
  height: 24vh;
  scroll-behavior: none;
}
.policiesDataGrid .css-11xur9t-MuiPaper-root-MuiTableContainer-root .css-15wwp11-MuiTableHead-root {
  height: 0px !important;
}
.policiesDataGrid .css-11xur9t-MuiPaper-root-MuiTableContainer-root .css-y8ay40-MuiTableCell-root {
  background-color: white !important;
  border: 0px !important;
}
.policiesDataGrid .css-11xur9t-MuiPaper-root-MuiTableContainer-root .css-1ex1afd-MuiTableCell-root {
  background-color: #D9D9D9;
  border-bottom: 28px solid white !important;
}
.policiesDataGrid .css-11xur9t-MuiPaper-root-MuiTableContainer-root .profilePicCell {
  background-color: white !important;
}
.policiesDataGrid .css-apqrd9-MuiTableBody-root {
  border: 2px solid red !important;
}

.agentDetail-text {
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/Agents/style.scss"],"names":[],"mappings":"AAAA;EACG,uBAAA;EACA,2BAAA;AACH;AACG;EAJH;IAKM,sBAAA;IACA,2BAAA;EAEJ;AACF;AAAG;EACG,6BAAA;EACA,qBAAA;EACA,YAAA;EACA,qBAAA;AAEN;AACM;EACG,sBAAA;AACT;AAEM;EACG,kCAAA;EACA,sBAAA;AAAT;AAGM;EACG,yBAAA;EACA,0CAAA;AADT;AAOM;EACG,kCAAA;AALT;AASG;EACG,gCAAA;AAPN;AAWG;EACG,6BAAA;EACA,qBAAA;EACA,YAAA;AATN;AAWM;EACG,sBAAA;AATT;AAYM;EACG,kCAAA;EACA,sBAAA;AAVT;AAaM;EACG,yBAAA;EACA,0CAAA;AAXT;;AAiBG;EACG,6BAAA;EACA,qBAAA;EACA,YAAA;EACA,qBAAA;AAdN;AAgBM;EACG,sBAAA;AAdT;AAiBM;EACG,kCAAA;EACA,sBAAA;AAfT;AAkBM;EACG,yBAAA;EACA,0CAAA;AAhBT;AAsBM;EACG,kCAAA;AApBT;AAwBG;EACG,gCAAA;AAtBN;;AA0BA;EACG,YAAA;AAvBH","sourcesContent":[".agents-container {\r\n   width: 81.7% !important;\r\n   margin-left: 18% !important;\r\n\r\n   @media (max-width: 1024px) {\r\n      width:100% !important;\r\n      margin-left:0px !important;\r\n   }\r\n\r\n   .css-11xur9t-MuiPaper-root-MuiTableContainer-root {\r\n      border-radius: 0px !important;\r\n      width: 97% !important;\r\n      height: 64vh;\r\n      scroll-behavior: none;\r\n      // border: 2px solid red;\r\n\r\n      .css-15wwp11-MuiTableHead-root {\r\n         height: 0px !important;\r\n      }\r\n\r\n      .css-y8ay40-MuiTableCell-root {\r\n         background-color: white !important;\r\n         border: 0px !important;\r\n      }\r\n\r\n      .css-1ex1afd-MuiTableCell-root {\r\n         background-color: #D9D9D9;\r\n         border-bottom: 28px solid white !important;\r\n         //   .profilePicCell{\r\n         //    background-color: white !important;\r\n         //   }\r\n      }\r\n\r\n      .profilePicCell {\r\n         background-color: white !important;\r\n      }\r\n   }\r\n\r\n   .css-apqrd9-MuiTableBody-root {\r\n      border: 2px solid red !important;\r\n   }\r\n\r\n   //For deployment\r\n   .css-13xy2my {\r\n      border-radius: 0px !important;\r\n      width: 97% !important;\r\n      height: 64vh;\r\n\r\n      .css-1wbz3t9 {\r\n         height: 0px !important;\r\n      }\r\n\r\n      .css-8coetn {\r\n         background-color: white !important;\r\n         border: 0px !important;\r\n      }\r\n\r\n      .css-q34dxg {\r\n         background-color: #D9D9D9;\r\n         border-bottom: 28px solid white !important;\r\n      }\r\n   }\r\n}\r\n\r\n.policiesDataGrid {\r\n   .css-11xur9t-MuiPaper-root-MuiTableContainer-root {\r\n      border-radius: 0px !important;\r\n      width: 97% !important;\r\n      height: 24vh;\r\n      scroll-behavior: none;\r\n\r\n      .css-15wwp11-MuiTableHead-root {\r\n         height: 0px !important;\r\n      }\r\n\r\n      .css-y8ay40-MuiTableCell-root {\r\n         background-color: white !important;\r\n         border: 0px !important;\r\n      }\r\n\r\n      .css-1ex1afd-MuiTableCell-root {\r\n         background-color: #D9D9D9;\r\n         border-bottom: 28px solid white !important;\r\n         //   .profilePicCell{\r\n         //    background-color: white !important;\r\n         //   }\r\n      }\r\n\r\n      .profilePicCell {\r\n         background-color: white !important;\r\n      }\r\n   }\r\n\r\n   .css-apqrd9-MuiTableBody-root {\r\n      border: 2px solid red !important;\r\n   }\r\n}\r\n\r\n.agentDetail-text {\r\n   color: white;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
